const parseJson = (content: string) => {
  const cleaned = content.trim().replace(/^```json\s*/i, '').replace(/^```/i, '').replace(/```$/, '').trim();
  return JSON.parse(cleaned);
};

export async function extractReceiptViaLocalModel(base64Image: string, mimeType: string) {
  const response = await fetch('/.netlify/functions/extract-receipt', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      mode: 'receipt',
      imageBase64: base64Image.split(',')[1],
      mimeType,
    }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Receipt extraction failed');
  return parseJson(data.content || '{}');
}

export async function parseStatementViaLocalModel(text: string) {
  const response = await fetch('/.netlify/functions/extract-receipt', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      mode: 'statement',
      text,
    }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Statement parsing failed');
  return parseJson(data.content || '[]');
}
